import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const CatalogoPage = lazy(() => import('../pages/catalogo/page'));
const CarritoPage = lazy(() => import('../pages/carrito/page'));
const CheckoutPage = lazy(() => import('../pages/checkout/page'));
const ContactoPage = lazy(() => import('../pages/contacto/page'));
const ComoComproPage = lazy(() => import('../pages/como-compro/page'));
const FaqPage = lazy(() => import('../pages/faq/page'));
const PoliticaDevolucionPage = lazy(() => import('../pages/politica-devolucion/page'));
const QuienesSomosPage = lazy(() => import('../pages/quienes-somos/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const SeguimientoPage = lazy(() => import('../pages/seguimiento/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/catalogo',
    element: <CatalogoPage />,
  },
  {
    path: '/carrito',
    element: <CarritoPage />,
  },
  {
    path: '/checkout',
    element: <CheckoutPage />,
  },
  {
    path: '/contacto',
    element: <ContactoPage />,
  },
  {
    path: '/como-compro',
    element: <ComoComproPage />,
  },
  {
    path: '/faq',
    element: <FaqPage />,
  },
  {
    path: '/devoluciones',
    element: <PoliticaDevolucionPage />,
  },
  {
    path: '/quienes-somos',
    element: <QuienesSomosPage />,
  },
  {
    path: '/seguimiento',
    element: <SeguimientoPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
